import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';

import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';
import withResponsiveLayout from 'hoc/withResponsive';
import Mobile from 'pages/AccountSetting/mobile';
import Tablet from 'pages/AccountSetting/tablet';
import Desktop from 'pages/AccountSetting/desktop';

const PageLayout = ({ location }) => {
    const { currentUser } = useAuth();
    const history = useHistory();
    const { width } = useViewport();
    const [incomingToken, setIncomingToken] = useState(null);

    useEffect(() => {
        const { token } = queryString.parse(location.search);
        if (token) setIncomingToken(token);
        if (currentUser?.profile_set_up) return history.push('/');
    }, [location?.search, currentUser?.profile_set_up]);

    const props = { incomingToken };

    const responsiveLayouts = {
        mobile: <Mobile {...props} />,
        tablet: <Tablet {...props} />,
        desktop: <Desktop {...props} />,
    };

    return withResponsiveLayout(width, responsiveLayouts);
};

export default PageLayout;
